import { render, staticRenderFns } from "./ShowSingleUserCard.vue?vue&type=template&id=33898e65&scoped=true&"
import script from "./ShowSingleUserCard.vue?vue&type=script&lang=js&"
export * from "./ShowSingleUserCard.vue?vue&type=script&lang=js&"
import style0 from "./ShowSingleUserCard.vue?vue&type=style&index=0&id=33898e65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33898e65",
  null
  
)

export default component.exports